import { apiClient } from "./apiclient";

// Backs the "Admin Reports View" page.
// Server: AdminReportController -> GET /reporting/admin-reports (+ /employees, + /modules)

// fromDate/toDate: "YYYY-MM-DD" (fromDate required by the backend)
// employeeId, moduleId, workType: optional — omit for "All"
export const getAdminReport = (
  token,
  { fromDate, toDate, employeeId, moduleId, workType, dateType }) =>
  apiClient.get("/reporting/admin-reports", {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      fromDate,
      ...(toDate && { toDate }),
      ...(employeeId && { employeeId }),
      ...(moduleId && { module: moduleId }),
        ...(workType && { workType }),
      ...(dateType && { dateType }),
    },
  });

export const getAdminReportEmployees = (token) =>
  apiClient.get("/reporting/admin-reports/employees", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAdminReportModules = (token) =>
  apiClient.get("/reporting/admin-reports/modules", {
    headers: { Authorization: `Bearer ${token}` },
  });
